import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Link2, Unplug, ArrowRightLeft, CheckCircle2 } from "lucide-react";
import { api, errMsg, fmtDate } from "../lib/api";

const ConnectForm = ({ onDone }) => {
  const [f, setF] = useState({ secret_key: "", mode: "live" });
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await api.post("/admin/revolut/connect", f); toast.success("Revolut connected"); onDone(); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="space-y-3 mt-4">
      <ol className="text-sm muted list-decimal pl-5 space-y-1">
        <li>In Revolut Business, open <b>Merchant → APIs</b> and copy your <b>Secret key</b>.</li>
        <li>Paste it below and press Connect. We set up payment notifications for you.</li>
      </ol>
      <div className="flex flex-wrap gap-2">
        <select className="input w-auto" value={f.mode} onChange={(e) => setF({ ...f, mode: e.target.value })} data-testid="revolut-mode-select">
          <option value="live">Live account (real payments)</option>
          <option value="sandbox">Test account (sandbox)</option>
        </select>
        <input type="password" className="input flex-1 min-w-[220px]" placeholder="Secret key" value={f.secret_key} onChange={(e) => setF({ ...f, secret_key: e.target.value })} data-testid="revolut-key-input" />
        <button onClick={go} disabled={busy || !f.secret_key} className="btn-coral flex items-center gap-1.5" data-testid="revolut-connect-btn"><Link2 className="w-4 h-4" />{busy ? "Connecting..." : "Connect"}</button>
      </div>
    </div>
  );
};

const Connected = ({ d, reload }) => {
  const off = async () => {
    if (!window.confirm("Disconnect Revolut? New membership sign-ups will stop until you reconnect.")) return;
    try { await api.post("/admin/revolut/disconnect"); toast.success("Revolut disconnected"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  const move = async () => {
    if (!window.confirm(`Email ${d.stripe_subscriber_count} pro(s) paying through Stripe and stop their Stripe renewal at the end of their current period?`)) return;
    try { const r = await api.post("/admin/revolut/move-stripe-subscribers"); toast.success(`${r.data.moved} pro(s) asked to switch`); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mt-4 space-y-3">
      <p className="flex items-center gap-2 text-sm text-emerald-700" data-testid="revolut-status"><CheckCircle2 className="w-4 h-4" />Connected ({d.mode === "live" ? "Live" : "Test"}) · key ending …{d.key_hint} · since {fmtDate(d.connected_at)}</p>
      <p className="text-xs muted">All new plan and Priority Leads subscriptions are now paid through Revolut and renew automatically.</p>
      <div className="flex flex-wrap gap-2">
        {d.stripe_subscriber_count > 0 && <button onClick={move} className="btn-navy btn-sm flex items-center gap-1.5" data-testid="revolut-move-stripe-btn"><ArrowRightLeft className="w-4 h-4" />Ask {d.stripe_subscriber_count} Stripe subscriber(s) to switch</button>}
        <button onClick={off} className="btn bg-rose-50 text-rose-700 hover:bg-rose-100 btn-sm flex items-center gap-1.5" data-testid="revolut-disconnect-btn"><Unplug className="w-4 h-4" />Disconnect</button>
      </div>
    </div>
  );
};

export const RevolutConnect = () => {
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get("/admin/revolut").then((r) => setD(r.data)).catch(() => setD({ connected: false })), []);
  useEffect(() => { load(); }, [load]);
  return (
    <section className="card p-6" data-testid="revolut-connect-card">
      <h2 className="font-bold">Revolut Business: membership payments</h2>
      <p className="text-sm muted mt-1">Pro plan and Priority Leads subscriptions are charged through your Revolut Business account.</p>
      {!d ? <p className="text-sm muted mt-4">Loading...</p> : d.connected ? <Connected d={d} reload={load} /> : <ConnectForm onDone={load} />}
    </section>
  );
};
